import React, { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { startEditElement } from "../../../actions/elementListAction";
import { Element } from "../../../models/elementModel";
import { SketchPicker } from "react-color";
import produce from "immer";
import { FontFamilies } from "../../../utils/constants";
import { IoColorPalette } from "react-icons/io5";
import { FaEraser } from "react-icons/fa";
export interface FontStylePropertiesProps {
  element: Element;
}

const FontStyleProperties: FC<FontStylePropertiesProps> = ({ element }) => {
  const dispatch = useDispatch();
  const [colorPicker, setColorPicker] = useState(false);
  // let colorPickerButtonClicked = false;
  return (
    <div className="container mt-3">
      {/* <div className="card">
        <div className="card-header" id="FontProperties">
            <h5 className="mb-0">
                <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#font-prop" aria-expanded="false" aria-controls="font-prop">Font Properties</button>
            </h5>
        </div>
        <div id="font-prop" className="collapse" aria-labelledby="FontProperties">
          <div className="card-body"> */}
            {!(element.type === 'video' || element.type === 'img') &&(
              <div>
                <div className="form-group row">
                  <label htmlFor="font-size" className="col-sm-4 col-form-label font-size-12 align-text-left">
                    Size
                  </label>
                  <div className="col-sm-7 remove-left-padding">
                    <input
                      type="text"
                      className="form-control theam-textbox items-align-left"
                      id="font-size"
                      value={element.styles.fontSize}
                      onChange={(e) => {
                        const newElement = produce(element, draft => { draft.styles.fontSize =    e.target.value})
                        dispatch(startEditElement(newElement));
                      }}
                    />
                  </div>
                  <span className="font-size-12">px</span>
                </div>
                <div className="form-group row">
                  <label htmlFor="font-color" className="col-sm-4 col-form-label font-size-12 align-text-left">
                    Color
                  </label>
                  <div className="col-sm-8">
                    <div className="row items-align-center">
                      {colorPicker && (
                        <SketchPicker
                          color={element.styles.color}
                          onChange={(color) => {
                            const newElement = produce(element, draft => { draft.styles.color = color.hex})
                            dispatch(startEditElement(newElement));
                          }}
                        />
                      )}
                      <button
                        className="btn btn-block btn-dark btn-theam"
                        onClick={() => {
                          setColorPicker(!colorPicker);
                        }}
                      >
                        <IoColorPalette size={25}/>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="font-color" className="col-sm-4 col-form-label font-size-12 align-text-left ">
                    Reset Color
                  </label>
                  <div className="col-sm-8">
                    <div className="row items-align-center">
                    <button className="btn btn-block btn-dark btn-theam" onClick={()=>{
                      const newElement = produce(element, draft => {  draft.styles.color = ""})
                      dispatch(startEditElement(newElement));
                    }}> <FaEraser size={25}/> </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {(element.type === 'btn' || element.type === 'lbl' || element.type === 'heading' || element.type === 'navbar' || element.type === 'collaps') &&(
              <div className="form-group row">
              <label htmlFor="font-family" className="col-sm-4 col-form-label font-size-12 align-text-left">
                Font
              </label>
              <div className="col-sm-8 remove-left-right-padding">
              <select
                  value={element.styles.fontFamily}
                  id="font-family"
                  className="form-control theam-textbox items-align-left"
                  onChange={(e) => {
                    const newElement = produce(element, draft => { draft.styles.fontFamily = e.target.value})
                    dispatch(startEditElement(newElement));
                  }}
                >{
                  FontFamilies.map((item, i) => {
                      return (
                        <option key={i} value={item.value} style={{fontFamily:item.value}}>
                          {item.name}
                        </option>
                      );
                    })
                }
                </select>
              </div>
            </div>
            )}
          {/* </div>
        </div>
      </div> */}
    </div>
  );
};

export default FontStyleProperties;
